import React from 'react';
import { styled } from '@teko/ui';
import {
  PreLoad as DefaultPreLoad,
  LoadingProps,
  PreLoadProps,
} from '@teko/ecommerce';
import { useGlobalData } from '../contexts/GlobalDataContext';
import { LogoLoading } from './LogoLoading';
import { Loading as BaseLoading } from '@teko/ds-desktop';

export const Loading: React.FC<LoadingProps> = ({
  isLoading,
  children,
}: LoadingProps) => {
  const { logo } = useGlobalData();
  return (
    <BaseLoading isLoading={isLoading} logo={(logo.loading || logo.lite).path}>
      {children}
    </BaseLoading>
  );
};

export const PreLoad: React.FC<PreLoadProps> = ({
  isLoading,
  ...props
}: PreLoadProps) => {
  const { logo } = useGlobalData();
  return (
    <DefaultPreLoad
      {...props}
      isLoading={isLoading}
      logo={(logo.loading || logo.lite)?.path}
    />
  );
};

const ContainerLoadingWrapper = styled.div`
  position: relative;
`;

const Container = styled.div`
  position: relative;
  transition: opacity 0.3s;
  &.loading-blur {
    clear: both;
    overflow: hidden;
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  max-height: 400px;
`;

interface ContainerLoadingProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  isLoading?: boolean;
}

export const ContainerLoading: React.FC<ContainerLoadingProps> = ({
  children,
  style,
  isLoading = true,
}: ContainerLoadingProps) => {
  const { logo } = useGlobalData();
  return (
    <ContainerLoadingWrapper>
      {isLoading && (
        <LoadingContainer style={style}>
          <LogoLoading logo={(logo.loading || logo.lite)?.path} />
        </LoadingContainer>
      )}
      <Container className={isLoading ? 'loading-blur' : ''}>
        {children}
      </Container>
    </ContainerLoadingWrapper>
  );
};
